import type { CommunityDetail } from 'models';
import { ContentWrapper } from 'ui';
import { Administrators, Members } from '../components';

type P = {
  community: CommunityDetail;
};

const CommunityMembers = ({ community }: P) => (
  <ContentWrapper aside={<Administrators community={community} />}>
    <Members community={community} />
  </ContentWrapper>
);

export default CommunityMembers;
